import styled from "styled-components";

const Styles = styled.img`

`;

export default Styles;
